/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/credit_line';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "UpdateCreditLineAutopaySettingsRequest": {
                "fields": {
                  "creditLineId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "autopaySettings": {
                    "type": ".squareup.corporate_card.resources.CreditLine.AutopaySettings",
                    "id": 2,
                    "rule": "optional"
                  },
                  "idempotenceToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "UpdateCreditLineAutopaySettingsResponse": {
                "fields": {
                  "creditLine": {
                    "type": ".squareup.corporate_card.resources.CreditLine",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.UpdateCreditLineAutopaySettingsRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.UpdateCreditLineAutopaySettingsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UpdateCreditLineAutopaySettingsRequest @ squareup/corporate_card/service/update_credit_line_autopay_settings.proto at 10:1
 */
export const UpdateCreditLineAutopaySettingsRequest = $root.lookupType('squareup.corporate_card.service.UpdateCreditLineAutopaySettingsRequest');
fixType(UpdateCreditLineAutopaySettingsRequest, {
  creditLineId: {
    notEmpty: true
  },
  idempotenceToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UpdateCreditLineAutopaySettingsRequest);
/**
 * SOURCE UpdateCreditLineAutopaySettingsResponse @ squareup/corporate_card/service/update_credit_line_autopay_settings.proto at 34:1
 */
export const UpdateCreditLineAutopaySettingsResponse = $root.lookupType('squareup.corporate_card.service.UpdateCreditLineAutopaySettingsResponse');
fixType(UpdateCreditLineAutopaySettingsResponse);
Builder.createAndAttachToType(UpdateCreditLineAutopaySettingsResponse);